import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UflaUser } from 'src/app/service/auth/ufla-user';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { OrganisationService } from '../../service/organisation/organisation.service';
import { NetzbetreiberDialogService } from '../netzbetreiber-dialog.service';
import { NetzbetreiberDataSource } from './netzbetreiber-data-source';
import { MatSort } from '@angular/material/sort';
import { Organisation } from '../../service/organisation/organisation';
import { ObjectPathService } from '../../service/common/deep-path/deep-path.service';

@Component({
    selector: 'ufla-netzbetreiberliste',
    templateUrl: './netzbetreiber-list.component.html',
    styleUrls: [
        './netzbetreiber-list.component.scss',
    ],
    standalone: false,
})
export class NetzbetreiberListComponent implements OnInit {
    private netzbetreiberDialogService = inject(NetzbetreiberDialogService);
    private authenticationService = inject(AuthenticationService);
    private organisationService = inject(OrganisationService);
    private route = inject(ActivatedRoute);


    public allColumnsToDisplay = [
        'name',
        'stromNetzbetreiberNummer',
        'zuweisungDeaktiviert',
        'typ',
        'kundenBetreuer',
        'schaltleitung',
        'updateDateTime',
    ];

    public limitedColumnsToDisplay = [
        'name',
        'stromNetzbetreiberNummer',
        'typ',
    ];

    public columnsToDisplay = this.limitedColumnsToDisplay;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  netzbetreiberList: NetzbetreiberDataSource = new NetzbetreiberDataSource();

  uflaUser: UflaUser;

  isUeNB = false;

  constructor() {
      this.uflaUser = this.route.snapshot.data.profile;
      if (this.authenticationService.isUenb(this.uflaUser)) {
          this.isUeNB = true;
          this.columnsToDisplay = this.limitedColumnsToDisplay;
      } else {
          this.columnsToDisplay = this.allColumnsToDisplay;
      }
  }

  ngOnInit() {
      this.netzbetreiberDialogService.observeNetzbetreiberChanged().subscribe(() => this.reloadOrganisationen());

      this.netzbetreiberList.sort = this.sort;
      this.netzbetreiberList.sortingDataAccessor = (item: Organisation, sortHeaderId: string) => {
          const value = ObjectPathService.objectPath(item, sortHeaderId);
          if (value === undefined || value === null) {
              return '';
          }

          if (typeof value === 'string' && !value.trim()) {
              return value;
          }

          return isNaN(+value) ? value.toLowerCase() : +value;
      };


      this.sort.sort({ id: 'name', start: 'asc', disableClear: false });
  }

  private reloadOrganisationen() {
      this.organisationService.getOrganisationen()
          .subscribe(orgs => {
              if (this.authenticationService.isUenb(this.uflaUser)) {
                  this.netzbetreiberList.data = orgs.filter(org => org.zuweisungDeaktiviert === false);
              } else {
                  this.netzbetreiberList.data = orgs;
              }
          });
  }

  public openDetail(orgId: string) {
      if (this.authenticationService.isAdmin(this.uflaUser)) {
          this.netzbetreiberDialogService.openDetail({ orgId, createNew: false });
      }
  }

}
